import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Zendesk: React.FC = () => {
  const [loaded, setLoaded] = useState(false);
  const loadImmediately = true;

  const loadZendeskChat = (trigger = false) => {
    const id = 'ze-snippet';
    const scriptIsOnPage = document.getElementById(id);
    if (scriptIsOnPage) return;
    const zdscript = document.createElement('script');
    zdscript.setAttribute('id', id);
    zdscript.src = 'https://static.zdassets.com/ekr/snippet.js?key=29c8f6bc-8e80-4074-b29f-00c263862ee9';
    document.getElementsByTagName('body')[0].appendChild(zdscript);

    window.zdonload = setInterval(
      () => {
        if (typeof zE !== 'undefined') {
          clearInterval(window.zdonload);
          zE(() => {
            setLoaded(true);
            if (trigger) {
              zE('messenger', 'open');
            }
          });
        }
      },
      250,
      null
    );
  };

  useEffect(() => {
    if (loadImmediately) {
      loadZendeskChat();
    }
  }, [loadImmediately]);

  const loadAndOpenZendeskChat = () => {
    if (!loaded) {
      loadZendeskChat(true);
    } else {
      zE('messenger', 'open');
    }
  };

  if (loaded || loadImmediately) return null;

  return (
    <ZendeskButton className="custom-zendesk-button" aria-label="Launch Help Chat Window" onClick={loadAndOpenZendeskChat}>
      <div shape="circle" className="sc-1w3tvxe-0 iQrZel">
        <button
          data-garden-id="buttons.icon_button"
          data-garden-version="8.13.0"
          type="button"
          shape="circle"
          aria-label="Open messaging window"
          className="sc-htpNat sc-1w3tvxe-1 ePnOda sc-EHOje bsmmQV"
        >
          <div aria-hidden="false" className="sc-1q9fwvy-0 gHHEeh">
            <svg position="right" className="sc-1k07fow-1 jPbmEF" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <path
                d="M10,18 L6,22 L6,18 L10,18 Z M17,6 C19.7614237,6 22,8.23857625 22,11 C22,13.7614237 19.7614237,16 17,16 L17,16 L7,16 C4.23857625,16 2,13.7614237 2,11 C2,8.23857625 4.23857625,6 7,6 L7,6 Z"
                id="🎨icon-fill"
                transform="translate(12.000000, 14.000000) scale(-1, 1) translate(-12.000000, -14.000000) "
              ></path>
            </svg>
          </div>
        </button>
      </div>
    </ZendeskButton>
  );
};

export default Zendesk;

const ZendeskButton = styled.div`
  height: 64px;
  width: 64px;
  transform: scale(0.75);
  position: fixed;
  bottom: 16px;
  right: 16px;
  border: 0;
  margin-top: 0;
  box-shadow: rgb(36 36 36 / 10%) 0 8px 24px 0, rgb(71 69 123 / 4%) 0 1px 4px 0;
  animation: 0.2s ease-in 0s 1 normal none running webSDKOnLoad, 0s ease 0s 1 normal none running undefined;
  z-index: 999999;
  border-radius: 50%;
  padding: 0;

  .iQrZel {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    box-shadow: rgb(36 36 36 / 10%) 0 8px 16px 0, rgb(36 36 36 / 4%) 0 1px 4px 0;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    background-color: #eba920 !important;
  }

  .bsmmQV {
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    transition: border-color 0.25s ease-in-out 0s, box-shadow 0.1s ease-in-out 0s, background-color 0.25s ease-in-out 0s, color 0.25s ease-in-out 0s;
    margin: 0;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: inherit;
    font-weight: 400;
    -webkit-font-smoothing: subpixel-antialiased;
    box-sizing: border-box;
    user-select: none;
    height: 40px;
    line-height: 38px;
    font-size: 14px;
    background-color: #0000;
    border: none;
    padding: 0;
    width: 40px;
    color: #68737d;
  }

  .ePnOda {
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    background-color: #eba920;
  }

  .jPbmEF {
    width: 40px;
    height: 40px;
    display: flex;
  }

  .gHHEeh {
    display: flex;
  }
`;
